export const MAX_IMAGE_SIZE = 8 * 1024 * 1024; // 8MB
export const MAX_VIDEO_SIZE = 30 * 1024 * 1024; // 30MB
